/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { IconArrowRight } from 'components/Icons';
import { cx } from '@linaria/core';
import { flex } from 'styles/utils';
import { v4 as uuidv4 } from 'uuid';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { useAuthActions } from 'modules/Auth/AuthContext';
import { useIsLoggedIn } from 'modules/Auth/hooks';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { Card } from './Card';
import { HorizontalLayout } from '../layout/HorizontalLayout';
import { HomeCard } from '../components/HomeCard';
import { useSetupComputeModal } from '../components/SetupComputeModal';
import { HomeCardId, SetupComputeMockData, mapIdToTitle } from '../constants';

export function Compute() {
  const { track } = useDataCollection();
  const openSetupComputeModal = useSetupComputeModal();
  const isLoggedIn = useIsLoggedIn();
  const router = useRouter();
  const { openLoginModal } = useAuthActions();
  const { enableLocalRunnersLDFF } = useFeatureFlagsLD();

  const handleFooterClick = useCallback(
    ({ footerLink, setupComputeType, isExternalLink }: typeof SetupComputeMockData[0]) => {
      if (footerLink) {
        track('Home Page -> Create a Cluster');

        if (isExternalLink) {
          window.open(footerLink, '_blank');
          return;
        }

        if (!isLoggedIn) {
          openLoginModal();
          return;
        }

        router.push(footerLink);
        return;
      }

      if (setupComputeType) {
        openSetupComputeModal(setupComputeType);
        track('Home Page -> Set Up Compute Clicked', { setupComputeType });
      }
    },
    [isLoggedIn, router],
  );

  // TODO: remove once flag is released
  const computeCards = SetupComputeMockData.filter((data) => {
    if (!enableLocalRunnersLDFF && ['connect-runner', 'connect-compute'].includes(data.id)) {
      return false;
    }
    return true;
  });

  return (
    <HomeCard
      title={mapIdToTitle[HomeCardId.Compute]}
      description="Deploying models on dedicated compute gives faster responses, lower latency, and better uptime."
    >
      <HorizontalLayout>
        {computeCards.map((data) => (
          <Card
            key={uuidv4()}
            icon={data.icon}
            title={data.title}
            body={data.body}
            badge={data.badge}
            badgeClassName={data?.badgeClassName ?? ''}
            footer={
              <a
                className={cx(flex.init, flex.gap.half, flex.justifyContent.center, flex.alignItems.center, 'link')}
                onClick={() => handleFooterClick(data)}
              >
                {data.footer}
                <IconArrowRight size={16} />
              </a>
            }
          />
        ))}
      </HorizontalLayout>
    </HomeCard>
  );
}
